exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "span.smaller{font-size:smaller}span.inherit{font-size:inherit}span.larger{font-size:larger}", "", {"version":3,"sources":["/var/lib/jenkins/jobs/GroupPay/jobs/QA2/jobs/QA-Pioneer-ALL-2-POC/workspace/pioneer-web/src/app/shared/confirmation-modal/confirmation-modal.component.css"],"names":[],"mappings":"AAAA,aACE,iBAAmB,CACpB,aAEC,iBAAmB,CACpB,YAEC,gBAAkB,CACnB","file":"confirmation-modal.component.css","sourcesContent":["span.smaller {\n  font-size: smaller;\n}\nspan.inherit {\n  font-size: inherit;\n}\nspan.larger {\n  font-size: larger;\n}\n"],"sourceRoot":""}]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /var/lib/jenkins/jobs/GroupPay/jobs/QA2/jobs/QA-Pioneer-ALL-2-POC/workspace/pioneer-web/src/app/shared/confirmation-modal/confirmation-modal.component.css
// module id = epPf
// module chunks = 0